import { render, staticRenderFns } from "./ImageLayout.vue?vue&type=template&id=dc8df910&scoped=true&"
import script from "./ImageLayout.vue?vue&type=script&lang=js&"
export * from "./ImageLayout.vue?vue&type=script&lang=js&"
import style0 from "./ImageLayout.vue?vue&type=style&index=0&id=dc8df910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8df910",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
